import { getApiClient } from "@punchup/utils";
import { ProductRow } from "@punchup/data/models";

export type ManagerSubscriptionProduct = Pick<
  ProductRow,
  | "id"
  | "name"
  | "description"
  | "description_details_bullets"
  | "preferred"
  | "price"
  | "comedian_id"
  | "created_at"
  | "stripe_product_id"
  | "stripe_price_id"
  | "subscription_tier"
>;

export interface UpdateSubscriptionRequest {
  comedianId: string;
  name?: string | null;
  description?: string | null;
  descriptionDetailsBullets?: string[] | null;
  preferred?: boolean;
}

export async function fetchManagerSubscriptions(
  comedianId: string
): Promise<ManagerSubscriptionProduct[]> {
  const response = await getApiClient().get<{
    data: ManagerSubscriptionProduct[];
  }>(`/api/v2/manager/subscriptions?comedian_id=${comedianId}`);
  return response.data;
}

export async function updateManagerSubscription(
  productId: string,
  payload: UpdateSubscriptionRequest
): Promise<void> {
  await getApiClient().patch<{ data: { id: string } }>(
    `/api/v2/manager/subscriptions/${productId}`,
    payload
  );
}
